import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalEncuestaSatisfaccionPreguntasComponent } from 'src/app/components/core/layouts/modal-encuesta-satisfaccion-preguntas/modal-encuesta-satisfaccion-preguntas.component';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { AlertType } from 'src/app/shared/models/alert.model';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { AlertsService } from 'src/app/shared/services/alerts.service';
import { EncuestaSatisfaccionService } from './encuesta-satisfaccion.service';

@Component({
  selector: 'app-encuesta-satisfaccion',
  templateUrl: './encuesta-satisfaccion.component.html',
  styleUrls: ['./encuesta-satisfaccion.component.scss']
})
export class EncuestaSatisfaccionComponent implements OnInit {

	public dataTable: DatoPaginadoModel;
	public headerTable: string[];
	public paginaActual: number = 1;
	
	public encuestaSatisfaccionForm: FormGroup;
	public encuestaSatisfaccionIdSeleccionada: number;
	private encuestaSatisfaccionPreguntas:any[] = [];
	get encuestaTienePreguntasConfiguradas(): boolean {
		return this.encuestaSatisfaccionPreguntas.some(t => t.activo);
	}
	get cantidadPreguntasConfiguradas(): number {
		return this.encuestaSatisfaccionPreguntas.filter(t => t.activo)?.length??0;
	}

	public showFilters = false;
	public filtrosForm: FormGroup;

	constructor(
		private formBuilder: FormBuilder,
		private encuestaSatisfaccionService: EncuestaSatisfaccionService, 
		private modalService: NgbModal,
		private _alertService: AlertsService,
		private _matSnackbar: MatSnackBar
	) { }

	ngOnInit() {
		this.headerTable = ['Nombre', 'Fecha inicio', 'Fecha final', 'Identificador interfaz', 'Estado', 'Acciones'];
		this.dataTable = {
			paging: {} as Paging
		} as DatoPaginadoModel;
		
		this.filtrosForm = this.createFiltrosForm();
		this.encuestaSatisfaccionForm = this.createncuestaSatisfaccionForm(); 

		this.consultarEncuestasSatisfaccion();
	}

	private createFiltrosForm(): FormGroup {
		return this.formBuilder.group({
			nombre: undefined,
			fechaInicio: undefined,
			fechaFinal: undefined,
			identificadorInterfaz: undefined,
			activo: undefined,
		});
	}

	private createncuestaSatisfaccionForm(): FormGroup {
		return this.formBuilder.group({
			nombre: [undefined, [Validators.required]],
			fechaInicio: [undefined, [Validators.required]],
			fechaFinal: [undefined, [Validators.required]],
			identificadorInterfaz: [undefined, [Validators.required]],
			activo: [{value:true, disabled:true}, [Validators.required]]
		});
	}

	public onPaginado(value: number) {
		this.paginaActual = value;
		this.consultarEncuestasSatisfaccion();
	}

	private consultarEncuestasSatisfaccion() {
		let request = { ...this.filtrosForm.value, numeroPagina: this.paginaActual };
		this.encuestaSatisfaccionService.get(request)
		.subscribe(resultado => {
			if (!resultado.result) return;
			this.dataTable = resultado.data as DatoPaginadoModel;
		});
	}

	public seleccionarEncuestaSatisfaccion(encuestaSatisfaccion: any) {
		this.encuestaSatisfaccionIdSeleccionada = encuestaSatisfaccion.id;
		this.encuestaSatisfaccionForm.get("activo").enable();
		this.encuestaSatisfaccionService.getById(this.encuestaSatisfaccionIdSeleccionada)
		.subscribe(response => {
			if(!response.result) return;
			this.encuestaSatisfaccionForm.patchValue({
				nombre: encuestaSatisfaccion.nombre,
				fechaInicio: new Date(encuestaSatisfaccion.fechaInicio),
				fechaFinal: new Date(encuestaSatisfaccion.fechaFinal),
				identificadorInterfaz: encuestaSatisfaccion.identificadorInterfaz,
				activo: encuestaSatisfaccion.activo,
			});
			this.encuestaSatisfaccionPreguntas = response.data.preguntas;
		})
	}

	public guardarEncuestaSatisfaccion() {
		if (this.encuestaSatisfaccionForm.invalid) {
			this._matSnackbar.open("Faltan campos por diligenciar", "Entendido", { duration: 4000 });
			return;
		}
		if (!this.encuestaTienePreguntasConfiguradas) {
			this._matSnackbar.open("Debe configurar por lo menos una pregunta para la encuesta", "Entendido", { duration: 4000 });
			return;
		}

		if (this.encuestaSatisfaccionIdSeleccionada) {
			this.onModificarEncuestaSatisfaccion();
			return;
		}
		this.onRegistrarEncuestaSatisfaccion();
	}

	private onRegistrarEncuestaSatisfaccion() {
		var request = {
			...this.encuestaSatisfaccionForm.value,
			preguntas: this.encuestaSatisfaccionPreguntas
		}
		this.encuestaSatisfaccionService.create(request)
		.subscribe(response => {
			if (!response.result) return;
			this._alertService.alert(response.control.alert_type as AlertType,
				response.control.message, window.location.pathname, `${response.control.code}`);
			this.encuestaSatisfaccionForm.reset({activo:true});
			this.encuestaSatisfaccionPreguntas = [];
			this.consultarEncuestasSatisfaccion();
		});
	}

	private onModificarEncuestaSatisfaccion() {
		const request = {
			id: this.encuestaSatisfaccionIdSeleccionada,
			...this.encuestaSatisfaccionForm.value,
			preguntas: this.encuestaSatisfaccionPreguntas
		}
		this.encuestaSatisfaccionService.update(request)
		.subscribe(resultado => {
			if (!resultado.result) return;
			this._alertService.alert(resultado.control.alert_type as AlertType,
				resultado.control.message, window.location.pathname, `${resultado.control.code}`);
			
			this.consultarEncuestasSatisfaccion();

			this.encuestaSatisfaccionIdSeleccionada = 0;
			this.encuestaSatisfaccionForm.get("activo").disable();
			this.encuestaSatisfaccionForm.reset({activo:true});
			this.encuestaSatisfaccionPreguntas = [];
		});
	}

	public eliminarEncuestaSatisfaccion(encuestaSatisfaccion: any) {
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.closed.subscribe(() => {
			this.encuestaSatisfaccionService.delete(encuestaSatisfaccion)
			.subscribe(response => {
				if (!response.result) return;
				this._alertService.alert(response.control.alert_type as AlertType,
					response.control.message, window.location.pathname, `${response.control.code}`);
				this.consultarEncuestasSatisfaccion();
			});
		});
	}

	public buscarEncuestasConFiltro() {
		this.paginaActual = 1;
		this.consultarEncuestasSatisfaccion();
	}

	public limpiarFiltrosDeBusqueda() {
		this.filtrosForm.reset();
		this.filtro_fechaInicioMinima = null;
		this.buscarEncuestasConFiltro();
	}

	public limpiarFormularioRegistroEncuestaSatisfaccion() {
		this.fechaInicioMinima = null;
		this.encuestaSatisfaccionIdSeleccionada = 0;
		this.encuestaSatisfaccionForm.get("activo").disable();
		this.encuestaSatisfaccionForm.reset({activo:true});
		this.encuestaSatisfaccionPreguntas = [];
	}

	public fechaInicioMinima: NgbDate;
	public onCheckDateForm(newDate: NgbDate) {
		this.fechaInicioMinima = newDate;
	}

	public filtro_fechaInicioMinima: NgbDate;
	public onCheckDateFilterForm(newDate: NgbDate) {
		this.filtro_fechaInicioMinima = newDate;
	}

	public abrirModalDePreguntas(){
		const modal = this.modalService.open(ModalEncuestaSatisfaccionPreguntasComponent, 
			{ size: 'xl', scrollable: true });
		modal.componentInstance.preguntas = this.encuestaSatisfaccionPreguntas;
		modal.closed.subscribe(result => {
			this.encuestaSatisfaccionPreguntas = result;
		});
	}
}
